<div>
  <input type="text" class="payu-blik-input" [value]="inputCode" (input)="inputCode = $event.target['value']"
         mask="000 000" inputmode="numeric" />
</div>